import { Button } from '@enterprise-ui/canvas-ui-react'
import EnterpriseIcon, { DownloadIcon } from '@enterprise-ui/icons'
import { COST_CHANGE_INSIGHTS_SUBMENU_DETAILS_MAP } from './constants'
const standardPages = [
  {
    name: 'Home',
    path: '/',
    reload: false,
    iconName: 'HouseIcon',
    groups: [],
  },
  {
    name: 'Cost Search',
    path: '/cost-search',
    reload: false,
    iconName: 'SearchIcon',
    groups: [],
  },
  {
    name: 'Spreadsheet Dashboard',
    path: '/spreadsheet-dashboard',
    reload: false,
    iconName: 'DashboardIcon',
    groups: [],
  },
  {
    name: 'Manage Custom Location Groups',
    path: '/manage-custom-location-groups',
    reload: false,
    iconName: 'BackroomLocationManagementIcon',
    groups: [],
  },
  {
    name: 'Manage Notifications',
    path: '/manage-notifications',
    reload: false,
    iconName: 'CommIcon',
    groups: [],
  },
]

const getInsightsPages = () => {
  const submenus = Object.keys(COST_CHANGE_INSIGHTS_SUBMENU_DETAILS_MAP)
    .map((key) => {
      const pageDetails = COST_CHANGE_INSIGHTS_SUBMENU_DETAILS_MAP[key]
      if (key === '/insights') {
        return null
      }

      return {
        name: pageDetails.SUBMENU_NAME,
        path: `/cost${key}`,
        reload: false,
        iconName: 'VisibleShowIcon',
      }
    })
    .filter((item) => item !== null)
  return [
    {
      name: 'Insights',
      path: '/insights',
      reload: false,
      iconName: 'VisibleShowIcon',
      end: true,
      groups: submenus,
      isRouteRequired: true,
    },
  ]
}

const getSavedViewPages = (
  savedViews,
  loadingSavedViews,
  downloadRequestFunc,
) => {
  if (!savedViews || !savedViews?.length) {
    return []
  } else {
    const groupsArray = []
    savedViews
      .sort((a, b) => (a.title > b.title ? 1 : -1))
      .forEach((view, index) => {
        groupsArray.push({
          name: (
            <>
              {view?.title}
              <Button
                className="hesp-download-button"
                aria-label={
                  'Download ' + view?.title + ' Saved View Spreadsheet'
                }
                type="ghost"
                iconOnly
                onClick={(event) => {
                  event.preventDefault()
                  event.stopPropagation()
                  downloadRequestFunc(view, index)
                }}
                isLoading={loadingSavedViews.includes(index)}
                key={'dropdownbutton_' + view?.title}
              >
                {!loadingSavedViews.includes(index) ? (
                  <EnterpriseIcon
                    className="hesp-download-icon hc-mr-none"
                    icon={DownloadIcon}
                  />
                ) : null}
              </Button>
            </>
          ),
          path: `/cost/saved-view/${view?.viewId}`,
          reload: false,
          iconName: 'SaveIcon',
          groups: [],
        })
      })
    return [
      {
        name: 'Saved Views',
        path: '/a-path-that-does-not-exist',
        reload: false,
        iconName: 'SaveIcon',
        groups: groupsArray,
        insertAfter: 'Insights',
        isRouteRequired: false,
      },
    ]
  }
}

export const getSideNavAppMenus = (
  savedViews,
  loadingSavedViews,
  downloadRequestFunc,
) => {
  return [
    ...standardPages,
    ...getInsightsPages(),
    ...getSavedViewPages(savedViews, loadingSavedViews, downloadRequestFunc),
  ]
}

export const getSideNavDynamicMenus = (
  savedViews,
  loadingSavedViews,
  downloadRequestFunc,
) => {
  return [
    ...getSavedViewPages(savedViews, loadingSavedViews, downloadRequestFunc),
  ]
}

export const itemHubApiKey =
  process.env.REACT_APP_ENV === 'prod'
    ? '4a11d225433c414d5d3c24941ad3c6e7292c1ae5'
    : '58a607d5595ff8443e1ea3e8ab20249ddba0cc50'
